import { Box, Paper } from "@mui/material";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import {
  GroupedBilletsYard,
  GroupedTorch,
} from "../../../models/torches.models";
import { useTheme } from "@mui/material/styles";
import { dataEntryTableStyles } from "../../../../../../shared/styles/dataEntryTableStyles";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

interface Props {
  data: (GroupedTorch | GroupedBilletsYard)[];
  columns: ColDef<GroupedTorch | GroupedBilletsYard>[];
}

export const ReadOnlyTable = ({ data, columns }: Props): JSX.Element => {
  const theme = useTheme();
  const styles = dataEntryTableStyles(theme);

  return (
    <Paper>
      <Box padding={1} sx={styles.smAgGridBox}>
        <AgGridReact<GroupedTorch | GroupedBilletsYard>
          rowData={data}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          loadingOverlayComponent={CenteredLazyLoading}
          {...defaultGridOptions}
        />
      </Box>
    </Paper>
  );
};
